export default __webpack_public_path__ + "static/media/346.0e036327.png";